var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCafeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#6A8860"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#6A8860"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0762 27.02C29.8042 27.02 31.2082 25.616 31.2082 23.888C31.2082 22.16 29.8042 20.756 28.0762 20.756H27.4642C27.4642 20.204 27.4282 19.832 27.4162 19.784L27.3202 18.968H19.1602H11.0002L10.8802 19.796C10.8562 19.952 10.4242 23.78 12.6202 26.372C13.4602 27.368 13.9042 28.364 14.1442 29.132H9.28418V30.992H30.1162V29.132H24.1402C24.3322 28.544 24.6442 27.8 25.1722 27.032H28.0762V27.02ZM28.0762 22.628C28.7722 22.628 29.3482 23.192 29.3482 23.9C29.3482 24.596 28.7842 25.172 28.0762 25.172H26.4802C26.9242 24.332 27.1762 23.444 27.3082 22.64H28.0762V22.628ZM22.2082 29.132H16.0882C15.8362 28.124 15.2842 26.648 14.0482 25.172C12.9082 23.816 12.7162 21.908 12.7042 20.84H19.1482H25.5922C25.5802 21.92 25.3882 23.828 24.2482 25.172C23.0002 26.636 22.4482 28.124 22.2082 29.132Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4323 17.4561C17.4323 16.9041 17.8763 16.4601 18.4283 16.4601H23.6003C25.1723 16.4601 26.4563 15.1761 26.4563 13.6041C26.4563 12.0321 25.1723 10.7481 23.6003 10.7481H21.6323C21.0803 10.7481 20.6363 10.3041 20.6363 9.75206V9.00806H18.7643V9.74006C18.7643 11.3121 20.0483 12.5961 21.6203 12.5961H23.6003C24.1523 12.5961 24.5963 13.0401 24.5963 13.5921C24.5963 14.1441 24.1523 14.5881 23.6003 14.5881H18.4283C16.8563 14.5881 15.5723 15.8721 15.5723 17.4441V18.1761H17.4323V17.4561Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafeActive);
export default __webpack_public_path__ + "static/media/cafeActive.ec363e7714369303e6cdc77c357a378c.svg";
export { ForwardRef as ReactComponent };